import {
  SET_SHARE_LINK_STATISTICS_SEARCHING,
} from './mutation-types.js'
import api from '@/api'

const state = {
  searching: false,
}

const mutations = {
  [SET_SHARE_LINK_STATISTICS_SEARCHING] (state, payload) {
    state.searching = payload
  },
}

const actions = {
  async getShareLinkStatisticsList ({commit, state, dispatch}, payload) {
    try {
      commit(SET_SHARE_LINK_STATISTICS_SEARCHING, true)
      const res = await api.monitorApi.getShareLinkStatistics(payload)
      commit(SET_SHARE_LINK_STATISTICS_SEARCHING, false)
      return res
    } catch (error) {
      commit(SET_SHARE_LINK_STATISTICS_SEARCHING, false)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
